import React, { useState } from 'react';
import { useSnackbar } from 'notistack';
import { Grid, Paper, TextField } from "@material-ui/core";
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import moment from 'moment';
import { backendDateFormat, fieldDateFormat } from '../../../constants';
import { withRouter } from 'react-router';
import { checkApiStatus } from '../../utils_v2';
import { ExportMenu, PageLoader } from '../../shared_elements';
import { globalGetService, globalPostService } from '../../../globalServices';
import { checkPermission } from '../../../console_management/utils_v2';
import { trackActivity } from '../../../utils/mixpanel';
import { Autocomplete } from '@material-ui/lab';

const MonthlyRevenueReport = ({ ownerList }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState({});
    const [start_date, setStartDate] = useState(null);
    const [end_date, setEndDate] = useState(null);
    const [asset_types, setAsset_types] = useState([]);
    const exportMonthlyRevenueReport = (extension) => {
        let validationInputs = {};
        validationInputs = {
            ...validationInputs,
            start_date: start_date ? '' : 'Please enter From Date',
            end_date: end_date ? '' : 'Please enter To Date',
        }
        if (start_date == 'Invalid date') {
            validationInputs = {
                ...validationInputs,
                start_date: 'Please enter From Date'
            }
        }
        if (end_date == 'Invalid date') {
            validationInputs = {
                ...validationInputs,
                end_date: 'Please enter To Date'
            }
        }
        if (start_date && end_date) {
            if (moment(end_date).isBefore(moment(start_date))) {
                validationInputs = {
                    ...validationInputs,
                    end_date: 'To Date Cannot be lesser than From Date'
                }
            }
        }
        if (moment(end_date).diff(moment(start_date), 'months', true) < 3) {
            enqueueSnackbar('Minimum of 3 months difference is required between From Date and To Date to generate the report.', { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
            return;
        }
        let assetsStr = asset_types.map(item => ({ id: item?.id, asset_type: item?.asset_type, asset_name: item?.asset_name }));
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
            setLoading(true)
            globalPostService(`console/custom-reports/monthly-revenue-report/`, { 'file_type': extension, 'start_date': moment(start_date).format(backendDateFormat), 'end_date': moment(end_date).format(backendDateFormat), 'asset_types':assetsStr })
                .then(response => {
                    setLoading(false);
                    if (checkApiStatus(response)) {
                        enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                        trackActivity('Console Management', { page_title: 'Custom Report', item_type: 'Export', event_type: 'Monthly Revenue Report Exported', event_desc: 'Monthly Revenue Report Exported Successfully' })
                        setError({}); setEndDate(null); setStartDate(null); setAsset_types([]);
                    } else {
                        // enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    }
                });
        } else {
            setError(validationInputs)
        }
    }
    const onResetErrorKey = (keyParam) => {
        setError({ ...error, [keyParam]: '' })
    }
    return (
        <Paper square>
            <Grid container spacing={0} alignItems='center'>
                <Grid item md={12}>
                    <div className='custom-rpt-card'>
                        <div className='rpt-card-header'>
                            <Grid container spacing={1}>
                                <Grid item md={9}>
                                    <h4>Monthly Revenue Report</h4>
                                    <p>Consolidated Monthly Revenue Summary by Asset and Contract. Includes Lease Rentals, Supplemental Rent, Payment Status and Variance Against Forecasts.</p>
                                </Grid>
                                <Grid item md={3}>
                                    {checkPermission('reports', 'custom_reports', 'EXP') ? <ExportMenu
                                        exportReportFn={(file) => exportMonthlyRevenueReport(file.extension)}
                                        files={[{ title: 'EXCEL', extension: 'xlsx' }]}
                                    /> : null}
                                </Grid>
                            </Grid>
                        </div>
                        <div className='rpt-card-body'>
                            <Grid container spacing={1}>
                                <Grid item md={6}>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <KeyboardDatePicker
                                            required
                                            margin="normal"
                                            id="start_date"
                                            label="From Date"
                                            format={fieldDateFormat}
                                            fullWidth
                                            InputLabelProps={{ shrink: true }}
                                            maxDate={moment()}
                                            value={start_date}
                                            error={error.start_date ? true : false}
                                            helperText={error.start_date ? error.start_date : ''}
                                            onFocus={() => onResetErrorKey('start_date')}
                                            onChange={(data) => { setStartDate(('start_date', moment(data).format(backendDateFormat))); onResetErrorKey('start_date') }}
                                            inputVariant='outlined'
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item md={6}>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <KeyboardDatePicker
                                            required
                                            margin="normal"
                                            id="end_date"
                                            label="To Date"
                                            format={fieldDateFormat}
                                            disabled={!start_date ? true : false}
                                            fullWidth
                                            InputLabelProps={{ shrink: true }}
                                            minDate={moment(start_date).add(3, 'months')}
                                            value={end_date}
                                            onFocus={() => onResetErrorKey('end_date')}
                                            error={error.end_date ? true : false}
                                            helperText={error.end_date ? error.end_date : ''}
                                            onChange={(data) => { setEndDate(('end_date', moment(data).format(backendDateFormat))); onResetErrorKey('end_date') }}
                                            inputVariant='outlined'
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid container spacing={1}>
                                    <Grid item md={12}>
                                          <p className='lessor-select'><span onClick={() => { setAsset_types(ownerList);}}>Select All Assets</span>{asset_types.length ? <span style={{ marginLeft: '8px' }} onClick={() => { setAsset_types([]) }} >Remove All Assets</span> : null}</p>
                                        <Autocomplete
                                            options={ownerList}
                                            getOptionLabel={option => option.asset_name}
                                            id='asset_types'
                                            value={asset_types}
                                            labelKey="name"
                                            valueKey="id"
                                            multiple
                                            onChange={(e, data) => { setAsset_types(data); }}
                                            renderInput={params => <TextField {...params} label='Assets' margin="normal" placeholder={`Select Asset(s)`} fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                </Grid>
            </Grid>
            {isLoading ? <PageLoader /> : null}
        </Paper>
    )
}
export default withRouter(MonthlyRevenueReport);